// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1N7GL","vLegacy":"SelectSecondary_vLegacy__3zrCM","error":"SelectSecondary_error__Rm0jG","disabled":"SelectSecondary_disabled__3-kkm"};